import { c as _c } from "react/compiler-runtime";
import { EditableCollectionsStatus } from "@opensea/graphql";
import { toLowerCase, toUpperCase } from "@opensea/utils";
import { parseAsArrayOf, parseAsStringLiteral, useQueryState } from "nuqs";
import { QUERY_PARAM_KEYS } from "./keys";
const parser = parseAsStringLiteral(EditableCollectionsStatus.map(value => toLowerCase(value)));
export function useEditableCollectionsStatusQueryParam(t0) {
  const $ = _c(17);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    shallow: t2
  } = t1;
  const shallow = t2 === undefined ? true : t2;
  let t3;
  if ($[2] !== shallow) {
    t3 = parseAsArrayOf(parser).withOptions({
      shallow
    }).withDefault([]);
    $[2] = shallow;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [statuses, setStatusesState] = useQueryState(QUERY_PARAM_KEYS.editableCollectionsStatus, t3);
  let t4;
  if ($[4] !== setStatusesState) {
    t4 = async function onSelectStatus(value) {
      await setStatusesState([toLowerCase(value)]);
    };
    $[4] = setStatusesState;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const onSelectStatus = t4;
  let t5;
  if ($[6] !== setStatusesState) {
    t5 = async function setStatuses(values) {
      await setStatusesState(values?.length ? [toLowerCase(values[0])] : null);
    };
    $[6] = setStatusesState;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const setStatuses = t5;
  let t6;
  if ($[8] !== statuses[0]) {
    t6 = statuses[0] ? toUpperCase(statuses[0]) : undefined;
    $[8] = statuses[0];
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== statuses) {
    t7 = statuses.map(toUpperCase);
    $[10] = statuses;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onSelectStatus || $[13] !== setStatuses || $[14] !== t6 || $[15] !== t7) {
    t8 = {
      status: t6,
      statuses: t7,
      onSelectStatus,
      setStatuses
    };
    $[12] = onSelectStatus;
    $[13] = setStatuses;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}